import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Form } from 'reactstrap';
import qs from 'qs';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';

import Serializer from 'helpers/form-serialize';
import { login } from 'redux/auth/actions';
import { selectState } from 'redux/selectors';
import ForgotPasswordButton from './ForgotPasswordButton';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';

class Login extends Component {
  static propTypes = {
    history: PropTypes.shape({}).isRequired,
    tokenInfoRequesting: PropTypes.bool.isRequired,
    formatMessage: PropTypes.func.isRequired,
    login: PropTypes.func.isRequired,
    email: PropTypes.string.isRequired,
    handleEmail: PropTypes.func.isRequired,
    password: PropTypes.string.isRequired,
    emailAutoFocus: PropTypes.bool,
  };

  static defaultProps = {
    emailAutoFocus: true,
  }

  state = {
    showPassword: false,
    email: this.props.email,
    password: this.props.password,
    autoFocus: this.props.emailAutoFocus,
    messageDialogOpen: false,
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.email!==this.props.email){
      this.setState({email: nextProps.email });
    }
  }
  onChangeValue = (event) => {
    this.setState({email: event.target.value});
    this.props.handleEmail(event.target.value);
  }

  onChangePassword = (event) => this.setState({password: event.target.value});

  toggleVisibility = () => this.setState(prevState => ({ showPassword: !prevState.showPassword }));

  handleMessageDialogClose = () => {
    this.setState({ messageDialogOpen: false });
  }

  render() {
    const { formatMessage, history, login, tokenInfoRequesting } = this.props;
    const { showPassword, email, password, autoFocus, messageDialogOpen } = this.state;
    return (
      <Form
        className="login-form h-100"
        onSubmit={(e) => {
          e.preventDefault();
          const loginData = Serializer.serialize(e.target, { hash: true });
          loginData.email = loginData.email.trim();
          login({
            ...loginData,
            onSuccess: (data) => {
              const accountRole = {
                2: 'Buyer',
                3: 'Distributor',
                4: 'Seller',
                5: 'Consumer',
              }[data.account.currentRoleId] || 'Personal';
              if (accountRole === 'Consumer') {
                this.setState({ messageDialogOpen: true });
                return;
              }
              const { redirect_url: redirectUrl, profileUrl, vendorEmail, asConsumer } = qs.parse(history.location.search.slice(1));
              if (redirectUrl) {
                window.location.href = decodeURI(redirectUrl);
                if (redirectUrl.indexOf('/+') !== -1 || redirectUrl.indexOf('/store-') !== -1) {
                  window.location.href = `${decodeURI(redirectUrl)}popup=true`;
                }
              } else if (profileUrl) {
                const role = {
                  2: 'Buyer',
                  3: 'Distributor',
                  4: 'Seller',
                  5: 'Consumer',
                }[data.user.account.currentRoleId] || 'Personal';
                const { account: { profile: { firstName, lastName } } } = data.user;
                if ((role !== 'Personal' && role !== 'Consumer') || (firstName && lastName)) {
                  const consumerPathname = role === 'Consumer' ? '?connect=true' : '';
                  const pathname = profileUrl ? `/${decodeURI(profileUrl)}${consumerPathname}` : '';
                  window.location.href = pathname;
                } else {
                  const vendorEmailPathname = vendorEmail ? `&vendorEmail=${encodeURIComponent(vendorEmail)}` : '';
                  const pathname = profileUrl ? `?profileUrl=${encodeURIComponent(profileUrl)}${vendorEmailPathname}` : '';
                  history.push(`/settings${pathname}`);
                  window.location.href = `/settings${pathname}`;
                }
              } else if (asConsumer) {
                const asConsumerPathname = asConsumer ? `?asConsumer=${encodeURIComponent(asConsumer)}` : '';
                history.push(`/settings${asConsumerPathname}`);
                window.location.href = `/settings${asConsumerPathname}`;
              } else {
                const publicPathname = history.location.pathname;
                history.push(publicPathname);
                window.location.href = publicPathname;
              }
              // if (process.env.NODE_ENV === 'development') {
              //   window.location.reload();
              // }
            },
          });
        }}
        autoComplete="none"
      >
        <div className="input-group-wrapper">
          <div className="input-group bottom-gap">
            <TextField
              autoComplete="none"
              autoFocus={true}
              className="input"
              id="username"
              name="email"
              value = {email}
              onChange={this.onChangeValue}
              placeholder={formatMessage('Email')}
              required
              inputProps={{
                autoCapitalize: "none",
              }}
            />
          </div>
          <div className="input-group">
            <TextField
              className="input"
              id="login_password"
              name="password"
              value= {password}
              onChange={this.onChangePassword}
              placeholder={formatMessage('Password')}
              required
              type={showPassword ? 'text' : 'password'}
              autoComplete="none"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton style={{ outline: 'none' }} onClick={this.toggleVisibility}>
                      {showPassword ? <Visibility /> : <VisibilityOff /> }
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </div>
          <div className='message-fields'>*Password is case sensitive</div>
        </div>
        <div className="action-group d-flex justify-content-between">
          <Button
            disabled={tokenInfoRequesting}
            type="submit"
            style={{
              paddingLeft: 20,
              paddingRight: 20,
              backgroundColor: '#4CAF50',
              color: 'white',
            }}
          >
            {formatMessage('Login')}
          </Button>
          <ForgotPasswordButton
            disabled={tokenInfoRequesting}
            formatMessage={formatMessage}
          />
        </div>
        <Dialog
          open={messageDialogOpen}
          onClose={this.handleMessageDialogClose}
          >
          <DialogTitle></DialogTitle>
          <DialogContent>
            <DialogContentText style={{ color: '#151b1e' }}>
              <div>
                <div style={{ marginBottom: '20px', fontSize: '20px' }}>
                  <span>We no longer offer consumer accounts</span>
                </div>
              </div>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <div className="text-center" style={{ width: '100%' }}>
              <Button onClick={this.handleMessageDialogClose} color="primary">
                OK
              </Button>
            </div>
          </DialogActions>
        </Dialog>
      </Form>
    );
  }
}

/* istanbul ignore next */
const mapStateToProps = state => ({
  ...selectState('auth', 'tokenInfo')(state, 'tokenInfo'),
});

/* istanbul ignore next */
const mapDispatchToProps = dispatch => ({
  login: payload => dispatch(login(payload)),
});

const wrappedLogin = connect(mapStateToProps, mapDispatchToProps)(Login);
wrappedLogin.displayName = 'Login';

export default wrappedLogin;
